import { Code, ConnectError } from '@connectrpc/connect'
import { DefaultOptions } from '@tanstack/react-query'

const MAX_RETRY_COUNT = 3

// Why not match the message: "Failed to fetch" is Chromium-only wording
const isFetchNetworkError = (error: unknown): boolean =>
  error instanceof ConnectError &&
  error.code === Code.Unknown &&
  error.cause instanceof TypeError

export const queryConfig: DefaultOptions = {
  queries: {
    retry: (failureCount, error) =>
      failureCount < MAX_RETRY_COUNT && isFetchNetworkError(error),
    retryDelay: (attemptIndex) => Math.min(500 * 2 ** attemptIndex, 3000),
    staleTime: 1000 * 60 * 5,
  },
}
